import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { useAppSelector } from "../app/appHooks";
import { ReportsPrintableViewer } from "./ReportsPrintableViewer";
import { useLocation } from "react-router-dom";
import { IReport } from "../../services/dashboard.services";

const useStyles = makeStyles<Theme, Boolean>((theme: Theme) =>
  createStyles({
    reportsContainer: {
      display: "flex",
      height: `calc(100vh - ${theme.mixins.toolbar.minHeight})`,
    },
    reportsViewerContainer: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      width: "100%",
      overflowX: "hidden",
    },
    [`@media print`]: {
      reportsContainer: {
        height: "100%",
      },
      reportsViewerContainer: {
        overflowY: "hidden",
      },
    },
  })
);

interface ReportPrintableLocationState {
  report: IReport;
  recommendationText?: string;
  communityName?: string;
}

export default function ReportsPrintable() {
  const showBanner = useAppSelector((state) => state.headerState.showBanner);

  /* ---- Hooks ---- */
  const classes = useStyles(showBanner);
  const location = useLocation<ReportPrintableLocationState>();
  const { report, recommendationText, communityName } = location.state || {};

  return (
    <div className={classes.reportsContainer}>
      <div className={classes.reportsViewerContainer} id="viewer-container">
        <ReportsPrintableViewer
          report={report}
          recommendationText={recommendationText}
          communityName={communityName}
        />
      </div>
    </div>
  );
}
